export default __webpack_public_path__ + "images/mapa-02.e21022fe4e7290b4762b56e88a02c370.png";